export default __webpack_public_path__ + "static/bounty-57c627677969fc8ea4e4def8ca1e8dac.png";